/*
 * @Author: Dzy
 * @Date: 2022-07-18 11:27:07
 * @LastEditors: Dzy
 * @LastEditTime: 2022-08-08 18:55:33
 * @Description: 配置信息存储
 */
import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', {
  state: () => {
    return {
      runMode: 2,
      title: '',
      icon: '',
      loginImg: '',
      language: 'zh_cn',
    }
  },

  actions: {
    update_runMode(data) {
      this.runMode = data
    },
    update_title(data) {
      this.title = data
    },
    update_language(data){
      this.language = data
    }
  },
  // 所有数据持久化 插件其他配置
  persist: {
    // 修改为 sessionStorage，默认为 localStorage
    storage: window.sessionStorage
  }
})
